
import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TrustIndicators from './components/TrustIndicators';
import Services from './components/Services';
import IndustryExpertise from './components/IndustryExpertise';
import Solutions from './components/Solutions';
import Testimonials from './components/Testimonials';
import About from './components/About';
import FeaturedJobs from './components/FeaturedJobs';
import CTA from './components/CTA';
import Footer from './components/Footer';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar scrolled={scrolled} />
      <Hero />
      <TrustIndicators />
      <Services />
      <IndustryExpertise />
      <Solutions />
      <Testimonials />
      <About />
      <FeaturedJobs />
      <CTA />
      <Footer />
    </div>
  );
}
